import React, { FC } from "react";
import { Table, Tooltip } from "antd";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { useBmsBusSaleRoDetailModel } from "../bmsBillBusRoModel"
import { ISaleDetailsList } from "../../bmsBillBusSo/bmsBillBusSoType";
import { ColumnsType } from "antd/es/table";

export const TableBox: FC<RouterParamType> = ({ id, mode, IFormRef }) => {
    const { detailMaterialLookList } = useBmsBusSaleRoDetailModel();
    const { replaceNav, selectedNavId } = useNavModel()
    // 公交销售退单 跳转 公交销售单
    const goToBusSaleDetail = (code: string) => {
        replaceNav(
            selectedNavId,
            "12-7",
            {
                id: code as string, mode: "",
                parentInfo: {
                    // mode,
                    selectedNavId,
                    // id
                }
            },
            true)
    }

    const MaterialColumns: ColumnsType<ISaleDetailsList> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '销售单号',
            width: 120,
            dataIndex: 'saleCode',
            fixed: "left",
            render: (t) => <Tooltip placement="topLeft" title={t} arrowPointAtCenter>
                <p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goToBusSaleDetail(t) }}>{t}
                </p></Tooltip>
        }, {
            title: '公交编码',
            width: 120,
            dataIndex: 'materialNo',
            fixed: "left",
            render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span">{text}</p></Tooltip>,
        }, {
            title: '商品编码',
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '替换编号',
            width: 160,
            dataIndex: 'replaceCode',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '销售数量',
            width: 120,
            dataIndex: 'saleNum',
        }, {
            title: '销售单价',
            width: 120,
            dataIndex: 'salePrice',
        }, {
            title: '退货数量',
            width: 120,
            dataIndex: 'num',
        }, {
            title: '退货单价',
            width: 120,
            dataIndex: 'price',
        }, {
            title: '退货金额',
            width: 120,
            dataIndex: 'amount',
        }, {
            title: '已退数量',
            width: 120,
            dataIndex: 'sreturnNum',
        }, {
            title: '品牌',
            width: 120,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 120,
            dataIndex: 'unitName',
        }, {
            title: '规格',
            width: 120,
            dataIndex: 'model',
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
        }
    ];


    return (
        <YhBox title="维修用料" style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={MaterialColumns}
                dataSource={detailMaterialLookList}
                pagination={false}
                scroll={{ x: 'max-content', y: 300 }}
            />
        </YhBox>
    )
}